import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { EventVendorMetadataInput } from '@peles/shared';
import * as bookingsApi from '../api/bookings';

export const bookingsKey = (eventId: string) => ['bookings', eventId] as const;

/** The Vendors view: the event's vendors, their stage, needs and money. */
export function useEventBookings(eventId: string | undefined) {
  return useQuery({
    queryKey: bookingsKey(eventId ?? ''),
    queryFn: () => bookingsApi.getEventBookings(eventId!),
    enabled: !!eventId,
  });
}

/**
 * Saves some of a booking's details. A booking is an entity link, so the
 * links refresh too (and, through `DEPENDENT_QUERIES`, the bookings).
 */
export function usePatchBooking() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ linkId, patch }: { linkId: string; patch: EventVendorMetadataInput }) =>
      bookingsApi.patchBooking(linkId, patch),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['entity-links'] });
    },
  });
}
